import { type ApiResponse } from "apisauce"

import { request } from "../../../services/api.ts"
import type {
  ApproveDeletionParams,
  DeletionRequestFilters,
  RejectDeletionParams,
  RetryDeletionParams
} from "./services.type.ts"

const BASE_URL = "/user/users"

export const PATHS = {
  list: `${BASE_URL}/deletion-requests/`,
  approve: (id: string) => `${BASE_URL}/deletion-requests/${id}/approve/`,
  reject: (id: string) => `${BASE_URL}/deletion-requests/${id}/reject/`,
  retry: (id: string) => `${BASE_URL}/deletion-requests/${id}/retry/`
}

export const getDeletionRequests = (
  params?: DeletionRequestFilters
): Promise<ApiResponse<any>> => {
  return request.api.get(PATHS.list, params)
}

export const approveDeletionRequest = ({
  id,
  admin_comment
}: ApproveDeletionParams): Promise<ApiResponse<any>> => {
  return request.api.post(PATHS.approve(id), { admin_comment })
}

export const rejectDeletionRequest = ({
  id,
  admin_comment
}: RejectDeletionParams): Promise<ApiResponse<any>> => {
  return request.api.post(PATHS.reject(id), { admin_comment })
}

export const retryDeletionRequest = ({
  id
}: RetryDeletionParams): Promise<ApiResponse<any>> => {
  return request.api.post(PATHS.retry(id))
}
